const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";

// Pathless layout route for protected routes
// This route is used to wrap all protected routes and redirect to plan settings if the user's subscription has expired
import { checkIfProtectedRouteCanBeSeen } from "@/react/components/shared/ProtectedRoute/useProtectedRoute";
import { planSettingsPath } from "@/react/helpers/urlHelpers";
export const Route = createFileRoute("/_protected")({
  beforeLoad: ({
    context,
    location
  }) => {
    const currentCommunity = context.punditUserContext?.currentCommunity;
    const canSeeProtectedRoute = checkIfProtectedRouteCanBeSeen(location.pathname, currentCommunity);
    if (!canSeeProtectedRoute) {
      redirect({
        to: planSettingsPath(),
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});